import { render, staticRenderFns } from "./PostTitleMod.vue?vue&type=template&id=b2a1d402"
import script from "./PostTitleMod.vue?vue&type=script&lang=js"
export * from "./PostTitleMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports